import React from "react";
import { AlertCircle } from "lucide-react";
import { COUNTRIES } from "../lib/countries";

const Label = ({ children }) => (
  <p className="font-sans text-[10px] uppercase tracking-overline text-slate-400 mb-2">{children}</p>
);

const ErrorText = ({ text }) => (
  <p className="mt-1.5 text-xs text-red-300/90 font-sans flex items-center gap-1.5">
    <AlertCircle className="w-3 h-3" /> {text}
  </p>
);

export function PhoneField({ label = "Phone number", required, dial, onDialChange, value, onChange, testid, error, errorKey }) {
  const hasError = !!error;
  return (
    <label className="block" data-error-key={errorKey}>
      <Label>
        {label}
        {required && <span className="text-[#D4AF37] ml-1">*</span>}
      </Label>
      <div className="flex gap-2">
        <select
          data-testid={`${testid}-dial`}
          value={dial}
          onChange={(e) => onDialChange(e.target.value)}
          className={`cosmic-input rounded-xl px-2 py-3 font-sans text-sm w-[110px] shrink-0 bg-transparent appearance-none cursor-pointer ${
            hasError ? "!border-red-400/80" : ""
          }`}
          style={{ colorScheme: "dark" }}
        >
          {COUNTRIES.map((c) => (
            <option key={`${c.code}-${c.dial}`} value={c.dial} className="bg-[#0B0E14] text-white">
              {c.flag} {c.dial}
            </option>
          ))}
        </select>
        <input
          data-testid={testid}
          type="tel"
          inputMode="tel"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="4XX XXX XXX"
          aria-invalid={hasError}
          className={`cosmic-input rounded-xl px-4 py-3 w-full font-sans text-base transition-colors ${
            hasError ? "!border-red-400/80 focus:!border-red-400 !bg-red-500/[0.04]" : ""
          }`}
        />
      </div>
      {hasError && <ErrorText text={error} />}
    </label>
  );
}

export function CountrySelect({ label = "Country", required, value, onChange, testid, error, errorKey }) {
  const hasError = !!error;
  return (
    <label className="block" data-error-key={errorKey}>
      <Label>
        {label}
        {required && <span className="text-[#D4AF37] ml-1">*</span>}
      </Label>
      <select
        data-testid={testid}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={hasError}
        className={`cosmic-input rounded-xl px-4 py-3 w-full font-sans text-base bg-transparent appearance-none cursor-pointer transition-colors ${
          hasError ? "!border-red-400/80 focus:!border-red-400 !bg-red-500/[0.04]" : ""
        }`}
        style={{ colorScheme: "dark" }}
      >
        <option value="" className="bg-[#0B0E14] text-slate-400">Select a country…</option>
        {COUNTRIES.map((c) => (
          <option key={c.code} value={c.name} className="bg-[#0B0E14] text-white">
            {c.flag} {c.name}
          </option>
        ))}
      </select>
      {hasError && <ErrorText text={error} />}
    </label>
  );
}
